.label-title {

  --lt-icon-gap: 4px;
  --lt-icon-reveal-delay: 250ms;
  --lt-label-left-padding:  var(--lt-icon-gap);
  --lt-pad-x: 12px;
  --lt-pad-y: 4px;
  --lt-empty-hit-area: 28px;

  position: relative;
  background-color: var(--color-bg-subtle);
  color: var(--color-text-primary);
  min-width: 1rem;
  min-height: 1rem;
  cursor: pointer;
  display: flex;
  padding: 4px 12px;
  border: 1px solid var(--color-border-primary);
  border-radius: var(--radius-md);
  transition: padding-left 200ms ease-in-out;
  transition-delay: 0ms; // no delay when returning to normal
  &:hover:not(.label-title--empty) {
    background-color: var(--color-bg-subtle-hover);
    color: var(--color-text-primary);
    box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.15);

  }

  .label-text {
    flex: 1 1 auto;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: max-width 120ms ease-in-out;
    max-width: 100%;
    padding: 0 4px;
  }

  .on-hover-icon {
    position: absolute;
    left: var(--lt-icon-gap);
    top: 50%;
    transform: translateY(-50%);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: opacity 100ms ease-in-out, visibility 0s linear;

    &.material-icons-outlined {
      font-family: 'Material Icons Outlined';

      &:hover,
      &:focus {
        font-family: 'Material Icons';
      }
    }
  }
}
.label-title--empty {
  border-color: transparent;
  background: transparent;
  box-shadow: none;
  padding: 0;
  min-width: var(--lt-empty-hit-area);
  min-height: max(var(--lt-empty-hit-area), var(--lt-icon-size));
}

.label-title--empty .label-text {
  display: none;
}

.label-title:has(.on-hover-icon):hover,
.label-title:has(.on-hover-icon):focus-within {
  padding-left:  var(--lt-icon-size);
  transition: padding-left 200ms ease-in-out var(--lt-icon-reveal-delay);
}

// Reveal icon and make it interactive only when visible
.label-title:hover .on-hover-icon,
.label-title:focus-within .on-hover-icon,
.on-hover-icon:focus {
  visibility: visible;
  opacity: 1;
  transition-delay: var(--lt-icon-reveal-delay);
}

.label-title:hover .on-hover-icon--clickable,
.label-title:focus-within .on-hover-icon--clickable,
.on-hover-icon--clickable:focus {
  pointer-events: auto;
}



.label-title-input {
  width: auto !important;
  border: none;
  background: var(--color-bg-subtle);
  vertical-align: middle;
  height: inherit;
}


.formatted-datetime {
  padding-right: 4px;
  cursor: pointer;
}
